export {Tag} from './lib/tag';
